import { getLocalApi } from "./localApi";
import { RoomGrade} from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllRoomGrades() : Promise<RoomGrade[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_room_grades, (dto:any) => ({
        name: dto.name,
        id: dto.id
    }), 'Unable to fetch room grades')
}